export const FlagsmithFeatures = Object.freeze({
  EHR_INTEGRATION_ISSUES: 'ehr_integration_issues',
  EHR_APPOINTMENTS: 'ehr_appointments',
  EHR_INTEGRATION_CLIENT_OPT_IN: 'ehr_integration_client_opt_in',
  SUPERVISOR_GROUPS: 'supervisor_groups',
  APP_EXPERIENCE_TOGGLE: 'app_experience_toggle',
  SHOW_APPOINTMENT_WORKFLOWS: 'show_appointment_workflows',
  DEBT_COLLECTOR_BANNER: 'debt_collector_banner',
  PROGRESS_NOTE_TYPES: 'progress_note_types',
  PROGRESS_NOTE_COMPARISON: 'progress_note_comparison',
  SHOW_MIC_ACTIVITY_WARNING: 'show_mic_activity_warning',
  SHOW_IS_DEMO_CLIENTS_IN_START_SESSION:
    'show_is_demo_clients_in_start_session',
  SHOW_MAGIC_EDIT: 'show_magic_edit',
  SESSION_SUMMARIES: 'session_summaries',
  AUDIT_REPORT: 'audit_report',
  USE_DEMO_NOTES_WITH_EBC_CONTENT: 'use_demo_notes_with_ebc_content',
  TRANSCRIPT_COPY: 'transcript_copy',
  PROGRESS_NOTE_DELETE: 'progress_note_delete',
  ALWAYS_SHOW_SAMPLE_SESSIONS: 'always_show_sample_sessions'
})
